<template>
  <div id="app">
    <grid-lines></grid-lines>
    <the-nav/>
    <div class="router-view">
      <!-- <transition
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-on:before-leave="beforeLeave"
        v-on:leave="leave"
        v-bind:css="false"
      >-->
      <router-view :key="$route.name"/>
      <!-- </transition> -->
    </div>
    <the-footer/>
  </div>
</template>

<script>
import { TweenMax } from "gsap/TweenMax";
import TheNav from "@/components/TheNav";
import TheFooter from "@/components/TheFooter";
import GridLines from "@/components/GridLines";

export default {
  components: {
    TheNav,
    TheFooter,
    GridLines
  },
  methods: {
    resize() {
      const w = window.innerWidth;
      const h = window.innerHeight;
      if (
        this.$store.state.windowSize.width === w &&
        this.$store.state.windowSize.height === h
      ) {
        return;
      }
      this.$store.commit("setWindowSize", w, h);
    }
    // beforeEnter: function(el) {
    //   // TweenMax.from(el, 0.5, { opacity: 0, ease: Cubic.easeInOut });
    // },
    // enter: function(el, done) {
    //   console.log("enter");
    //   console.log(this.$refs.routerView.$refs.viewContent);
    //   done();
    // },
    // beforeLeave: function(el) {
    //   console.log("before leave");
    //   console.log(this.$refs.routerView.$refs.viewContent);
    //   // TweenMax.to(el, 0.5, { opacity: 0, ease: Cubic.easeInOut });
    // },
    // leave: function(el, done) {
    //   // console.log("leave");
    //   // console.log(this.$refs.routerView.$refs.viewContent);
    //   done();
    // }
  },
  mounted() {
    this.resize();
    // this.$store.dispatch("getWorks");
    window.addEventListener("resize", this.resize, false);
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/main.scss";

.router-view {
  position: relative;
  min-height: 100vh;
  display: flex;
}
</style>

